/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react"
import { Link } from "react-router-dom"
import { OVERVIEW_PAGE_CONTENT } from "../constants"
import { getAssetPath } from "../../../utils/assets"

function LiveLifeDashboardEmptyState({ unfinishedSurveyExists, version }) {
  const isV2 = String(version) === "2"
  const content = isV2 ? OVERVIEW_PAGE_CONTENT.live_life_v2 : OVERVIEW_PAGE_CONTENT.live_life
  const surveyName = isV2 ? "PQ Index" : "LiveLife Score"

  return (
    <div className="dashboard-body">
      <div className="container dashboard" id="dashboard-10dwc">
        <div className="d-flex align-items-center justify-content-between my-4">
          <img src={getAssetPath(content.logoAssetName)} />
        </div>
        <div className="row text-center justify-content-center">
          <div className="col-lg-8">
            <h1 className="mb-4">
              {`Welcome to the ${surveyName}`}
            </h1>
            <p>
              {content.description}
            </p>
            <Link className="btn btn-link" to="/about-livelife">{`What is ${surveyName}?`}</Link>
            <div className="text-center mt-5">
              <Link className="btn btn-main" to="/livelife/intro">{`${unfinishedSurveyExists ? "Start" : "Continue"} Survey`}</Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
export default LiveLifeDashboardEmptyState
